import classNames from 'classnames'
import React from 'react'
import {Link} from 'react-router-dom'
import {LocationDescriptor} from 'history'

import Anchor from '../Anchor'
import AnchorNewTab from '../AnchorNewTab'

import '../../../scss/components/_linked-section.scss'

interface SharedComponentProps {
  children: React.ReactNode
  className?: string
  element?: React.ElementType
  onClick?: (args: unknown) => void
  to: LocationDescriptor
}

interface WithLinkProps {
  isExternalLink?: false
}

interface WithExternalLinkProps {
  isExternalLink: true
  shouldOpenNewTab?: boolean
}

type LinkedSectionProps = SharedComponentProps & (WithLinkProps | WithExternalLinkProps)

const LinkedSection: React.FC<LinkedSectionProps> = ({
  children,
  className,
  element = 'section',
  onClick,
  to,
  ...rest
}) => {
  const cx = classNames('c-linked-section', className)
  const ElementProp = element
  const ExternalLinkElement = rest.isExternalLink && rest.shouldOpenNewTab ? AnchorNewTab : Anchor
  const commonProps = {
    className: 'c-linked-section__link',
    'aria-hidden': true,
    tabIndex: -1,
    onClick,
  }

  return (
    <ElementProp className={cx}>
      {rest.isExternalLink ? (
        <ExternalLinkElement {...commonProps} href={to}>
          &nbsp;
        </ExternalLinkElement>
      ) : (
        <Link {...commonProps} to={to}>
          &nbsp;
        </Link>
      )}
      {children}
    </ElementProp>
  )
}

export default LinkedSection
